class StringUtils {
    static EMPTY = '';
    static SPACE = ' ';
    static LF = "\n";
    static CR = "\r";

    static isEmpty(value) {
        return value == null || value.length === 0;
    }

    static isNotEmpty(value) {
        return !StringUtils.isEmpty(value);
    }

    static isBlank(value) {
        if (value == null) {
            return true;
        }

        let trimmedValue = value.trim();
        return trimmedValue.length === 0;
    }

    static isNotBlank(value) {
        return !StringUtils.isBlank(value);
    }
}

export default StringUtils;


// WEBPACK FOOTER //
// ./src/_utils/StringUtils.js